import { toCatchupFilter } from "./ToCatchupFilter";

export async function basketballPossessionCatchup(messages, currentState, updateState) {
  let tempEntities = currentState.entities;

  if (!tempEntities || !tempEntities.length) {
    return;
  }

  const relevantEvents = toCatchupFilter(messages, currentState);

  if (!relevantEvents.length) {
    return;
  }

  const possessionEvents = relevantEvents.filter((msg) => msg.eventType === "possession");
  const lastPossessionEvent = possessionEvents[possessionEvents.length - 1];
  const possessionArrowEvents = relevantEvents.filter((msg) => msg.eventType === "possessionArrow");
  const lastPossessionArrowEvent = possessionArrowEvents[possessionArrowEvents.length - 1];
  if (lastPossessionEvent) {
    tempEntities.find((team) => team.entityId === lastPossessionEvent.entityId).hasPossession = true;
    tempEntities.find((team) => team.entityId !== lastPossessionEvent.entityId).hasPossession = false;
  }
  if (lastPossessionArrowEvent) {
    tempEntities.find((team) => team.entityId === lastPossessionArrowEvent.entityId).hasArrow = true;
    tempEntities.find((team) => team.entityId !== lastPossessionArrowEvent.entityId).hasArrow = false;
  }
  updateState("entities", tempEntities);
}
